import { Label } from '@primer/react';
import { BreadcrumbVariants } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import doOverflow from "../../../../content/components/Breadcrumbs/images/do-overflow.png";
import dontOverflow from "../../../../content/components/Breadcrumbs/images/dont-overflow.png";
import * as React from 'react';
export default {
  Label,
  BreadcrumbVariants,
  PropTableValues,
  doOverflow,
  dontOverflow,
  React
};